/**
 * Format a number.
 * @param value   Number value.
 * @param options Number format
 * @returns Formatted number.
 */
export const formatNumber = (value: number, options: Intl.NumberFormatOptions = { maximumFractionDigits: 0 }) =>
    value.toLocaleString(undefined, options);
